import React, { useCallback, useState, useEffect } from 'react'
import { store } from "@root/store/index";
import { Select, Form, Button, Table, Input, Pagination, message, Row, Col } from 'antd';
import { SearchOutlined, RedoOutlined } from '@ant-design/icons';
import { getHelpRelation, setAuditConfirm } from "@root/common/service";
import type { ColumnsType } from 'antd/es/table';
import "./_style.scss"

const { Option } = Select;
interface DataType {
  key: number | string;
  auditStatus: number | string; // 国家审核状态 0审核通过  1- 2待审核
  confirmStatus: number | string; // 支援医院确认状态 0通过 1拒绝 2未确认 
  adjustType: string; // 调整类型 0新增帮扶 1解除帮扶
  year: number | string; // 年度
  batchNumber: number | string;  // 批次
  recipientProvince: string;  // 受援医院省份
  recipientInstituteProvince: string | number;  //受援医院省份
  recipientInstituteName: string;  // 受援医院名称
  subject: string;  // 学科
  subjectId: number | string;  // 学科
  supportProvince: string;  // 支援医院省份
  supportInstituteName: string;  // 支援医院名称
  supportInstituteProvince: string | number;
}

function Index() {

  const columns: ColumnsType<DataType> = [
    {
      title: '国家审核状态',
      dataIndex: 'auditStatus',
      key: 'auditStatus',
      width: 72,
      render: (_, a) => (
        <>
          {(() => {
            if (a.confirmStatus === '1') {
              return (<span style={{ color: '#ff5733' }}>-</span>)
            } else if (a.auditStatus === '2') {
              return (<span style={{ color: '#ff8d1a' }}>待审核</span>)
            } else if (a.auditStatus === '1') {
              return (<span style={{ color: 'red' }}>审核退回</span>)
            } else if (a.auditStatus === '0') {
              return (<span style={{ color: '#43cf7c' }}>审核通过</span>)
            }
          })()}
        </>
      ),
    },
    {
      title: '支援医院确认状态',
      dataIndex: 'confirmStatus',
      key: 'confirmStatus',
      width: 60,
      render: (_, a) => (
        <>
          {(() => {
            if (a.confirmStatus === '0') {
              return (<span style={{ color: '#2a82e4' }}>通过</span>)
            } else if (a.confirmStatus === '2') {
              return (<span style={{ color: '#ff8d1a' }}>未确认</span>)
            } else {
              return (<span style={{ color: '#ff5733' }}>拒绝</span>)
            }
          })()}
        </>
      ),
    },
    {
      title: '调整类型',
      dataIndex: 'adjustType',
      key: 'adjustType',
      width: 80,
      render: (_, a) => (
        <>
          {(() => {
            if (a.adjustType === '0') {
              return (<span style={{ color: '#fff', backgroundColor: '#2a82e4', padding: '3px', borderRadius: '11px' }}>新增帮扶</span>)
            } else {
              return (<span style={{ color: '#fff', backgroundColor: '#ff8d1a', padding: '3px', borderRadius: '11px' }}>解除帮扶</span>)
            }
          })()}
        </>
      ),
    },
    {
      title: '年度',
      dataIndex: 'year',
      key: 'year',
      width: 50,
    },
    {
      title: '批次',
      dataIndex: 'batchNumber',
      key: 'batchNumber',
      width: 30,
    },
    {
      title: '受援医院省份',
      dataIndex: 'recipientProvince',
      key: 'recipientProvince',
      width: 60,
      render: (_, a) => (
        <>
          {(() => {
            let recipientProvince: any = ''
            provinceArr.forEach((e: any) => {
              if (a.recipientInstituteProvince === e.value) {
                recipientProvince = e.label
              }
            })
            return (<span>{recipientProvince}</span>)
          })()}
        </>
      ),
    },
    {
      title: '受援医院名称',
      dataIndex: 'recipientInstituteName',
      key: 'recipientInstituteName',
    },
    {
      title: '学科',
      dataIndex: 'subject',
      key: 'subject',
      width: 80,
      render: (_, a) => (
        <>
          {(() => {
            let subject: any = ''
            subjectIdArr.forEach((e: any) => {
              if (a.subjectId === parseFloat(e.id)) {
                subject = e.name
                return
              }
            })
            return (<span>{subject}</span>)
          })()}
        </>
      ),
    },
    {
      title: '支援医院省份',
      dataIndex: 'supportProvince',
      key: 'supportProvince',
      width: 60,
      render: (_, a) => (
        <>
          {(() => {
            let supportProvince: any = ''
            provinceArr.forEach((e: any) => {
              if (a.supportInstituteProvince === parseFloat(e.value)) {
                supportProvince = e.label
                return
              }
            })
            return (<span>{supportProvince}</span>)
          })()}
        </>
      ),
    },
    {
      title: '支援医院名称',
      dataIndex: 'supportInstituteName',
      key: 'supportInstituteName',
    },
  ];

  // const data: DataType[] 


  const [form1] = Form.useForm();
  const [data, setData] = useState<DataType[]>();
  const [nowYear, setNowYear] = useState<number>()
  const [current, setCurrent] = useState(1);
  const [total, setTotal] = useState<number>()
  const [provinceArr, setProvinceArr] = useState<any>([])
  const [searchValue, seetSearchValue] = useState<any>([])
  const [subjectIdArr, setSubjectIdArr] = useState<any>([])
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const getAll = useCallback(async (e: number) => {
    const keys: Array<string> = Object.keys(searchValue)
    const values = Object.values(searchValue)
    const arr: any = values.reduce(function (r, el, i) {
      if (!!el) { r += `${keys[i]}=${el}&` }
      return r
    }, '')
    console.log(arr);
    const { rows, total } = await getHelpRelation(`${arr}pageNum=${e}&pageSize=10`);
    rows.forEach((el: any) => {
      el.key = el.id
    })
    setData(rows)
    setTotal(total)
  }, [searchValue])

  useEffect(() => {
    console.log(store.getState());
    const date = new Date()
    setNowYear(date.getFullYear())
    setProvinceArr(store.getState().directionaries.chinaProvinceData)
    setSubjectIdArr(store.getState().directionaries.subjectData)
    seetSearchValue({})
    getAll(1)
  }, [])

  const onChange = useCallback((e: any) => {
    console.log(e);
    setCurrent(e)
    getAll(e)
  }, [getAll])
  const handleChange = useCallback((e: any) => {
    console.log(e);
  }, [])
  const onFinish = useCallback((e: any) => {
    console.log(e);
    seetSearchValue(e)
    const keys: Array<string> = Object.keys(e)
    const values = Object.values(e)
    const arr: any = values.reduce(function (r, el, i) {
      if (!!el) {
        r += `${keys[i]}=${el}&`
      }
      return r
    }, '')
    console.log(arr);
    const getOne = async () => {
      const { rows, total } = await getHelpRelation(`${arr}pageNum=${1}&pageSize=10`);
      rows.forEach((el: any) => {
        el.key = el.id
      })
      setData(rows)
      setTotal(total)
    }
    getOne()
    setCurrent(1)
  }, [])
  const onFinishFailed = useCallback((e: any) => {
    console.log(e);
  }, [])
  const onReset = useCallback(() => {
    form1.resetFields();
    getAll(1)
  }, [form1, getAll])
  const start = useCallback((e: string) => {
    const setOne = async () => {
      const { code, msg } = await setAuditConfirm({
        ids: selectedRowKeys,
        statusEnum: e,
        returnReason: ""
      })
      if (code === 200) {
        message.success(`${msg}`);
        getAll(1)
        setCurrent(1)
      } else {
        message.error(`${msg}`);
      }
    }
    setOne()
  }, [selectedRowKeys, getAll])
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  // console.log('selectedRowKeys changed: ', selectedRowKeys);
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;

  return (
    <div style={{ padding: '15px', background: '#fff', overflow: 'auto' }}>
      <div className='top'>
        <Form
          name="provinceSet"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="inline"
          form={form1}
          labelCol={{span: 8}}
          wrapperCol={{span: 16}}
        >
          <Row>
            <Col span={8}><Form.Item
              label="年度"
              // label="&emsp;&emsp;&emsp;&emsp;年度"
              name="year"
            >
              <Select
                placeholder="请选择年度"
                onChange={handleChange}
                allowClear
                style={{ width: 180 }}
              >
                <Option value={nowYear}>{nowYear}</Option>
              </Select>
            </Form.Item>
            </Col>
            <Col span={8}><Form.Item
              label="批次"
              name="batchNumber"
            >
              <Select
                placeholder="请选择批次"
                onChange={handleChange}
                allowClear
                style={{ width: 180 }}
              >
                <Option value="1">1</Option>
              </Select>
            </Form.Item>
            </Col>
            <Col span={8}><Form.Item
              label="学科"
              name="subjectId"
            >
              <Select
                placeholder="请选择学科"
                onChange={handleChange}
                allowClear
                style={{ width: 180 }}
              >
                {subjectIdArr.map((e: any, i: number) => {
                  return <Option value={e.id} key={i}>{e.name}</Option>
                })}
              </Select>
            </Form.Item>
            </Col>
            <Col span={8}><Form.Item
              label="支援医院省份"
              name="supportInstituteProvince"
            >
              <Select
                placeholder="请选择省份"
                onChange={handleChange}
                allowClear
                style={{ width: 180 }}
              >
                {provinceArr.map((e: any, i: number) => {
                  return <Option value={e.value} key={i}>{e.label}</Option>
                })}
              </Select>
            </Form.Item>
            </Col>
            <Col span={8}><Form.Item
              label="受援医院省份"
              name="recipientInstituteProvince"
            >
              <Select
                placeholder="请选择省份"
                onChange={handleChange}
                allowClear
                style={{ width: 180 }}
              >
                {provinceArr.map((e: any, i: number) => {
                  return <Option value={e.value} key={i}>{e.label}</Option>
                })}
              </Select>
            </Form.Item>
            </Col>
            <Col span={8}><Form.Item
              label="审核状态"
              name="auditStatus"
            >
              <Select
                placeholder="请选择状态"
                onChange={handleChange}
                allowClear
                style={{ width: 180 }}
              >
                <Option value="0">审核通过</Option>
                <Option value="1">未通过</Option>
                <Option value="2">待审核</Option>
              </Select>
            </Form.Item>
            </Col>
            <Col span={8}><Form.Item
              label="确认状态"
              name="confirmStatus"
            >
              <Select
                placeholder="请选择状态"
                onChange={handleChange}
                allowClear
                style={{ width: 180 }}
              >
                <Option value="0">通过</Option>
                <Option value="1">拒绝</Option>
                <Option value="2">未确认</Option>
              </Select>
            </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="支援医院名称" name="support_institute_name" ><Input placeholder="请输入医院名称" style={{ width: 180 }} /></Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="受援医院名称" name="recipient_institute_name" ><Input placeholder="请输入医院名称" style={{ width: 180 }} /></Form.Item>
            </Col>
          </Row>
          <Row style={{width: '100%', margin: '10px 0'}}>
            <Col span={24} style={{textAlign: 'right'}}>
              <Button type="primary" htmlType="submit">查询</Button>
              <Button type="primary" onClick={onReset} style={{ marginLeft: '15px' }} >重置</Button>
            </Col>
          </Row>
        </Form>
      </div>

      <div className='midBtn'>
        <Button type="primary" onClick={() => start('0')} disabled={!hasSelected}>审核通过</Button>
        <Button type="primary" onClick={() => start('1')} disabled={!hasSelected}>审核退回</Button>
      </div>

      <div className='tableBottom'>
        <Table size='middle' pagination={false} rowSelection={rowSelection} columns={columns} dataSource={data} />
        <Pagination current={current} onChange={onChange} total={total} showSizeChanger={false} />
      </div>
    </div>
  )
}

export default Index